module.exports = __webpack_public_path__ + "img/grocery-boy-text.12a48ad2.svg";